// extracted by mini-css-extract-plugin
export var carrierIcon = "_xz-0";
export var carrierLogo = "_xz-1";
export var detailsSection = "_xz-2";